/**
 * 翻譯系統 - 符合項目指導原則
 * 
 * 翻譯已分離到 src/config/locales/*.json 文件中
 * 此文件提供向後兼容性
 */

// 同步載入翻譯
const loadTranslationsSync = () => {
  const translations: Record<string, any> = {};
  
  try {
    translations.en = require('./locales/en.json');
    translations.zh = require('./locales/zh.json');
    translations['zh-cn'] = require('./locales/zh-cn.json');
    translations.ja = require('./locales/ja.json');
    translations.ko = require('./locales/ko.json');
  } catch (error) {
    console.error('Error loading translations:', error);
  }
  
  return translations;
};

// 向後兼容的TRANSLATIONS對象
export const TRANSLATIONS = loadTranslationsSync();

// 支援的語言
export const SUPPORTED_LANGUAGES = [
  { 
    code: 'en', 
    name: 'English', 
    nativeName: 'English', 
    flag: '🇺🇸' 
  },
  { 
    code: 'zh', 
    name: 'Chinese Traditional', 
    nativeName: '繁體中文', 
    flag: '🇹🇼' 
  },
  { 
    code: 'zh-cn', 
    name: 'Chinese Simplified', 
    nativeName: '简体中文', 
    flag: '🇨🇳' 
  },
  { 
    code: 'ja', 
    name: 'Japanese', 
    nativeName: '日本語',
    flag: '🇯🇵'
  },
  { 
    code: 'ko', 
    name: 'Korean', 
    nativeName: '한국어',
    flag: '🇰🇷'
  }
];

// 預設語言
export const DEFAULT_LANGUAGE = 'en';

// 向後兼容的翻譯函數
export const useTranslation = (language = DEFAULT_LANGUAGE) => {
  return (key: string) => {
    const keys = key.split('.');
    let result: any = TRANSLATIONS[language as keyof typeof TRANSLATIONS];

    for (const k of keys) {
      if (result && typeof result === 'object') {
        result = result[k];
      } else {
        return key;
      }
    }

    return typeof result === 'string' ? result : key;
  };
};

// 語言管理器
export const LanguageManager = {
  getCurrentLanguage: () => {
    return localStorage.getItem('language') || DEFAULT_LANGUAGE;
  },
  
  setLanguage: (lang: string) => {
    const supportedCodes = SUPPORTED_LANGUAGES.map(l => l.code);
    if (supportedCodes.includes(lang)) {
      localStorage.setItem('language', lang);
      return true;
    }
    return false;
  },
  
  getLanguageInfo: (languageCode: string) => {
    return SUPPORTED_LANGUAGES.find(lang => lang.code === languageCode);
  },
  
  getSupportedLanguages: () => {
    return SUPPORTED_LANGUAGES;
  }
}; 
